module.exports = __webpack_public_path__ + "static/img/rank1.9dadfe8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank/rank1.webp
// module id = GQ/B
// module chunks = 0